import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Dropdown } from '../Dropdown/Dropdown.js';
import { MenuProvider, MenuRenderProp } from './MenuContext/MenuProvider.js';
import { useMenu } from './useMenu/useMenu.js';

var Menu = function (_a) {
    var id = _a.id, children = _a.children, props = __rest(_a, ["id", "children"]);
    var providerValue = useMenu({ id: id });
    return (jsx(MenuProvider, __assign({ value: providerValue }, { children: jsx(Dropdown, __assign({}, props, { children: jsx(MenuRenderProp, { children: children }) })) })));
};

export { Menu };
//# sourceMappingURL=Menu.js.map
